/* eslint-disable react/prop-types,react/no-array-index-key,react/prefer-stateless-function */
import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

const MyTasksNav = props => {
  useEffect(() => {
    // eslint-disable-next-line no-undef
    $(`#panelGroupMenu_c_4`).collapse(props.isOpen ? 'show' : 'hide');
  }, [props.isOpen]);

  return (
    <div className="panel panel-default">
      <div className="panel-heading" role="tab" id="panelGroupMenu_h_4">
        <a
          className="dropdown-toggle dropdown-toggle-collapse collapsed"
          role="button"
          data-toggle="collapse"
          data-parent="#panelGroupMenu"
          href={null}
          aria-expanded="false"
          aria-controls="panelGroupMenu_c_4"
          title={t('Пользователи')}
          onClick={props.onToggle}
        >
          <i
            className="fa fa-universal-access fa-lg fa-fw"
            aria-hidden="true"
          />{' '}
          {t('Пользователи')}
        </a>
      </div>
      <div
        id="panelGroupMenu_c_4"
        className="panel-collapse collapse"
        role="tabpanel"
        aria-labelledby="panelGroupMenu_h_4"
      >
        <div className="list-group">
          <NavLink
            to="/users/top-users/by-earn-money"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="list-group-item-val">
              {t('Топ пользователей')}
            </span>
          </NavLink>
          <NavLink
            to="/users/my-users-black-list"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="list-group-item-val">
              {t('Мой черный список')}
            </span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

MyTasksNav.defaultProps = {
  isOpen: false,
  onToggle: () => {}
};

MyTasksNav.propTypes = {
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func
};

export default MyTasksNav;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Sidebar/Navs/UsersNav.js